var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade show invalid-feedback",
      attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v("Nieuwe tijdslot")
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: {
                  type: "button",
                  "data-dismiss": "modal",
                  "aria-label": "Close"
                },
                on: { click: _vm.handleClose }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _vm.type === "individueel"
                ? _c("select-field", {
                    attrs: {
                      error: _vm.session.error,
                      name: "session",
                      options: _vm.sessions,
                      multiple: false,
                      clearable: false,
                      label: "Training"
                    },
                    model: {
                      value: _vm.session.value,
                      callback: function($$v) {
                        _vm.$set(_vm.session, "value", $$v)
                      },
                      expression: "session.value"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("time-field", {
                      attrs: {
                        error: _vm.start.error,
                        label: "Vanaf",
                        name: "start"
                      },
                      model: {
                        value: _vm.start.value,
                        callback: function($$v) {
                          _vm.$set(_vm.start, "value", $$v)
                        },
                        expression: "start.value"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("time-field", {
                      attrs: {
                        error: _vm.end.error,
                        label: "Tot",
                        name: "end"
                      },
                      model: {
                        value: _vm.end.value,
                        callback: function($$v) {
                          _vm.$set(_vm.end, "value", $$v)
                        },
                        expression: "end.value"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("checkbox-field", {
                attrs: {
                  error: _vm.repeat.error,
                  label: "Beschikbaarheid herhalen",
                  name: "repeat"
                },
                model: {
                  value: _vm.repeat.value,
                  callback: function($$v) {
                    _vm.$set(_vm.repeat, "value", $$v)
                  },
                  expression: "repeat.value"
                }
              }),
              _vm._v(" "),
              _vm.repeat.value
                ? _c("div", [
                    _c("div", { staticClass: "row align-items-center" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-3" },
                        [
                          _c("input-field", {
                            attrs: {
                              error: _vm.amount.error,
                              type: "number",
                              label: "",
                              name: "amount"
                            },
                            model: {
                              value: _vm.amount.value,
                              callback: function($$v) {
                                _vm.$set(_vm.amount, "value", $$v)
                              },
                              expression: "amount.value"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("select-field", {
                            attrs: {
                              error: _vm.interval.error,
                              name: "interval",
                              options: [
                                {
                                  label: "Dag(en)",
                                  code: "day"
                                },
                                {
                                  label: "Week/Weken",
                                  code: "week"
                                }
                              ],
                              multiple: false,
                              clearable: false
                            },
                            model: {
                              value: _vm.interval.value,
                              callback: function($$v) {
                                _vm.$set(_vm.interval, "value", $$v)
                              },
                              expression: "interval.value"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _vm.interval.value.code == "week"
                      ? _c("div", { staticClass: "row mb-2" }, [
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.monday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "monday" }
                                  },
                                  [_vm._v("m")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.monday.value,
                                      expression: "monday.value"
                                    }
                                  ],
                                  attrs: { id: "monday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.monday.value)
                                      ? _vm._i(_vm.monday.value, null) > -1
                                      : _vm.monday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.monday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.monday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.monday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.monday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.tuesday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "tuesday" }
                                  },
                                  [_vm._v("d")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.tuesday.value,
                                      expression: "tuesday.value"
                                    }
                                  ],
                                  attrs: { id: "tuesday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.tuesday.value)
                                      ? _vm._i(_vm.tuesday.value, null) > -1
                                      : _vm.tuesday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.tuesday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.tuesday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.tuesday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.tuesday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.wednesday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "wednesday" }
                                  },
                                  [_vm._v("w")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.wednesday.value,
                                      expression: "wednesday.value"
                                    }
                                  ],
                                  attrs: { id: "wednesday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.wednesday.value)
                                      ? _vm._i(_vm.wednesday.value, null) > -1
                                      : _vm.wednesday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.wednesday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.wednesday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.wednesday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.wednesday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.thursday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "thursday" }
                                  },
                                  [_vm._v("d")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.thursday.value,
                                      expression: "thursday.value"
                                    }
                                  ],
                                  attrs: { id: "thursday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.thursday.value)
                                      ? _vm._i(_vm.thursday.value, null) > -1
                                      : _vm.thursday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.thursday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.thursday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.thursday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.thursday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.friday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "friday" }
                                  },
                                  [_vm._v("v")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.friday.value,
                                      expression: "friday.value"
                                    }
                                  ],
                                  attrs: { id: "friday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.friday.value)
                                      ? _vm._i(_vm.friday.value, null) > -1
                                      : _vm.friday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.friday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.friday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.friday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.friday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.saturday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "saturday" }
                                  },
                                  [_vm._v("z")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.saturday.value,
                                      expression: "saturday.value"
                                    }
                                  ],
                                  attrs: { id: "saturday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.saturday.value)
                                      ? _vm._i(_vm.saturday.value, null) > -1
                                      : _vm.saturday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.saturday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.saturday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.saturday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.saturday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-auto" }, [
                            _c(
                              "div",
                              {
                                staticClass: "day",
                                class: { active: _vm.sunday.value }
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "icon",
                                    attrs: { for: "sunday" }
                                  },
                                  [_vm._v("z")]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.sunday.value,
                                      expression: "sunday.value"
                                    }
                                  ],
                                  attrs: { id: "sunday", type: "checkbox" },
                                  domProps: {
                                    checked: Array.isArray(_vm.sunday.value)
                                      ? _vm._i(_vm.sunday.value, null) > -1
                                      : _vm.sunday.value
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$a = _vm.sunday.value,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(
                                              _vm.sunday,
                                              "value",
                                              $$a.concat([$$v])
                                            )
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.sunday,
                                              "value",
                                              $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1))
                                            )
                                        }
                                      } else {
                                        _vm.$set(_vm.sunday, "value", $$c)
                                      }
                                    }
                                  }
                                })
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Vindt plaats " + _vm._s(_vm.message()) + " tot en met"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row align-items-center" }, [
                      _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("input-field", {
                            attrs: {
                              error: _vm.end_repeat.error,
                              name: "end_repeat",
                              type: "date"
                            },
                            model: {
                              value: _vm.end_repeat.value,
                              callback: function($$v) {
                                _vm.$set(_vm.end_repeat, "value", $$v)
                              },
                              expression: "end_repeat.value"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button", "data-dismiss": "modal" },
                on: { click: _vm.handleClose }
              },
              [_vm._v("Annuleren")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.handleSave()
                  }
                }
              },
              [_vm._v("Tijdslot opslaan")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c("p", [_vm._v("Herhaal elke")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Agenda/NewDate.vue?vue&type=template&id=7158a07f&
// module id = 418
// module chunks = 0